import { useSelector } from "react-redux";

const useRootEntity = (id, entity, companyId) => {
	const addresses = useSelector(
		(store) => store.votingStore.addresses.addresses
	);
	let result;
	if (entity === "houses") {
		addresses.forEach((companyObj) => {
			if (companyObj.companyId === companyId) {
				companyObj.regions.forEach((regionObj) => {
					regionObj.streets.forEach((streetObj) => {
						if (streetObj.streetId === id) {
							result = streetObj;
						}
					});
				});
			}
		});
	}
	if (entity === "regions") {
		addresses.forEach((companyObj) => {
			if (companyObj.companyId === id) {
				result = companyObj;
			}
		});
	}
	return result;
};

export default useRootEntity;
